<template>
  <Input.Group compact class="mts-base-input-range">
    <Input v-model:value="modelValue[0]" class="!border-r-0" @change="changeStart" />
    <Input class="input-range-split !border-x-0 bg-white !px-0" placeholder="~" readonly />
    <Input v-model:value="modelValue[1]" class="!border-l-0" @change="changeEnd" />
  </Input.Group>
</template>

<script lang="ts" setup>
  import { Input } from 'ant-design-vue';

  defineOptions({ name: 'BaseInputRange' });

  export type InputRangeValue = [string | undefined, string | undefined];

  const modelValue = defineModel<InputRangeValue>('value', { default: [] });

  function changeStart(e) {
    modelValue.value = [e.target.value, modelValue.value[1]];
  }
  function changeEnd(e) {
    modelValue.value = [modelValue.value[0], e.target.value];
  }
</script>

<style lang="less">
  .mts-base-input-range {
    display: flex !important;
    height: 28px;

    .ant-input.input-range-split {
      flex-shrink: 0;
      width: 20px;
      text-align: center;
      pointer-events: none;
    }
  }
</style>
